module.exports = __webpack_public_path__ + "media/images/swifticons/roundlock-b921c0cfdffeca0d4eadd47f5409eb5e.svg";